<template>
  <div class="autocomplete">
    <div v-if="options.length && showPanel" class="options">
      <div
        v-for="(option, index) in options"
        :key="index"
        class="option"
        @click="selectOption(option)"
      >
        {{ itemName ? option[itemName] : option }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    keyword: [String, Number],
    options: Array,
    identifier: String,
    itemName: String,
  },
  data() {
    return {
      current: null,
      showPanel: false,
    };
  },
  watch: {
    options(val) {
      if (val.length) {
        this.setCurrent();
      }
    },
    keyword() {
      this.showPanel = true;
    },
    showPanel(val) {
      console.log(val)
    },
  },
  methods: {
    selectOption(option) {
      // Bug: had to combine bothe false instance
      this.showPanel = false;
      this.$nextTick(() => {
        this.showPanel = false;
      })

      this.$emit("selected", this.identifier, option);
    },
    setCurrent() {
      if (this.options.length) {
        this.current = this.options[0];
      }
    },
  },
  destroyed() {
    this.showPanel = false
  },
};
</script>

<style lang="scss" scoped>
.autocomplete {
  position: absolute;
  width: 100%;
  z-index: 10;

  .options {
    overflow: auto;
    background-color: white;
    border-radius: 8px;
    box-shadow: 0px 0px 24px 0px rgba(0, 0, 0, 0.20);
    height: 156px;
    max-width: 354px;

    .option {
      height: 52px;
      padding: 0px 12px;
      color: #000;
      font-family: Inter;
      font-size: 16px;
      font-style: normal;
      font-weight: 400;
      line-height: normal;
      display: flex;
      align-items: center;

      &:hover {
        background: #F3F2FF;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// autocomplete.vue?434d8464